import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  Event,
  NavigationEnd,
  PRIMARY_OUTLET,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OwlDateTimeIntl } from 'ng-pick-datetime';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { createDateFormats } from './core/factories/date-formats.factory';
import { createDateTranslations } from './core/factories/date-translations.factory';
import { PendingService } from './core/services/base/pending.service';
import { TranslationService } from './core/services/translation.service';
import { TitlesService } from './core/services/visual/titles.service';
import { PRELOAD_MODULES } from './core/config/constants';

const getDataAttribute = (route: ActivatedRoute, attributeName: string) => {
  const children: ActivatedRoute[] = route.children;
  for (const child of children) {
    if (child.outlet !== PRIMARY_OUTLET) {
      continue;
    }

    const attribute = getDataAttribute(child, attributeName);
    if (attribute) {
      return attribute;
    }
  }

  return route.snapshot.data[attributeName];
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    // Date config
    { provide: OwlDateTimeIntl, useFactory: createDateTranslations, deps: [ TranslationService ] },
    { provide: OWL_DATE_TIME_FORMATS, useFactory: createDateFormats, deps: [ TranslationService ] },
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  constructor(
    private router: Router,
    private pendingService: PendingService,
    private translate: TranslateService,
    private dateTimeAdapter: DateTimeAdapter<any>,
    private activeRoute: ActivatedRoute,
    private titlesService: TitlesService,
  ) { }

  ngOnInit() {
    this.initTranslations();
    this.initRouterEvents();
    registerLocaleData(localeEs);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private initTranslations = () => {
    const defaultLang = 'es';
    this.translate.setDefaultLang(defaultLang);
    this.translate.use(defaultLang);
    this.dateTimeAdapter.setLocale(defaultLang);
  }

  private initRouterEvents = () => {
    this.subscription = this.router.events
      .pipe(
        filter(
          (event: Event) => (event instanceof RouteConfigLoadStart
            || event instanceof RouteConfigLoadEnd
            || event instanceof NavigationEnd
          )
        )
      )
      .subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          const title = getDataAttribute(this.activeRoute.root, 'title');
          if (title) {
            this.titlesService.setTranslatingTitle(title);
          }
          window.scrollTo(0, 0);
        } else if (!PRELOAD_MODULES) {
          if (event instanceof RouteConfigLoadStart) {
            this.pendingService.addBlockingPending();
          } else if (event instanceof RouteConfigLoadEnd) {
            this.pendingService.removeBlockingPending();
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/app.component.ts